module.exports = __webpack_public_path__ + "assets/images/instagram.4686ab30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-media/instagram.svg
// module id = 346
// module chunks = 1